import { Component, ElementRef, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { AdiantamentoService } from 'administrativo-lib';
import { Adiantamento, AdiantamentoDocumento, BaseResourceFormComponent, DateFormatPipe, FuncaoService, GlobalService, LoginContabil } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { AdiantamentoDocumentoService } from '../service/adiantamento-documento.service';

@Component({
  selector: 'lib-adiantamento-view',
  templateUrl: './adiantamento-view.component.html'
})
export class AdiantamentoViewComponent extends BaseResourceFormComponent<Adiantamento, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public listaDocumentos: Array<AdiantamentoDocumento>;


  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private messageService: MessageService,
    protected globalService: GlobalService,
    public funcaoService: FuncaoService,
    protected documentoService: AdiantamentoDocumentoService,
    protected adiantamentoService: AdiantamentoService) {
    super(new Adiantamento(), injector, Adiantamento.converteJson, adiantamentoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      numero: [null, [Validators.required]],
      mes: [null, [Validators.required]],
      data_adiantamento: [null, [Validators.required]],
      data_vencimento: [null, [Validators.required]],
      data_liberacao: [null],
      data_prestacao: [null],
      data_partida: [null],
      data_chegada: [null],
      parecer: [null],
      descricao_parecer: [null],
      especie: [null, [Validators.required]],
      situacao: [null, [Validators.required]],
      valor_adiantado: [null, [Validators.required]],
      valor_complemento: [null],
      oficio: [null, [Validators.required]],
      motivo: [null, [Validators.required]],
      numero_conta: [null],
      agencia: [null],
      banco: [null],
      beneficiario: [null, [Validators.required]],
      tipo_beneficiario: [null, [Validators.required]],
      cargo_beneficiario: [null, [Validators.required]],
      destino: [null],
      empenho: [null, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      exercicio: [this.login.exercicio]
    });
  }

  protected afterLoad() {
    this.entidade.data_adiantamento = new DateFormatPipe().transform(this.entidade.data_adiantamento, ['local']);
    this.entidade.data_vencimento = new DateFormatPipe().transform(this.entidade.data_vencimento, ['local']);
    this.entidade.data_liberacao = new DateFormatPipe().transform(this.entidade.data_liberacao, ['local']);
    this.entidade.data_partida = new DateFormatPipe().transform(this.entidade.data_partida, ['local']);
    this.entidade.data_chegada = new DateFormatPipe().transform(this.entidade.data_chegada, ['local']);
    this.entidade.data_prestacao = new DateFormatPipe().transform(this.entidade.data_prestacao, ['local']);
  }
  protected parametrosExtras(): {} {
    return { relations: 'empenho,empenho.exercicio,exercicio,orgao' };
  }
  protected afterInit(): void {
  }
  protected campoFoco(): ElementRef {
    return null;
  }
  protected beforeSubmit(): void {
  }
  protected afterSubmit(entidade: Adiantamento): void {
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public obterSituacao(idx: string) {
    switch (idx) {
      case 'A':
        return 'ATIVO';
      case 'I':
        return 'INATIVO';
      default:
        return '-';
    }
  }
  public obterTipo(idx: string) {
    switch (idx) {
      case 'S':
        return 'SERVIDOR PÚBLICO';
      case 'A':
        return 'AGENTE POLÍTICO';
      case 'V':
        return 'VEREADOR';
      default:
        return '-';
    }
  }

  public obterEspecie(idx: string) {
    switch (idx) {
      case 'N':
        return 'NUMERARIAS';
      case 'D':
        return 'DIÁRIAS';
      default:
        return '-';
    }
  }

  public obterParecer(idx: string) {
    switch (idx) {
      case 'F':
        return 'FAVORÁVEL';
      case 'D':
        return 'DESFAVORÁVEL';
      default:
        return '-';
    }
  }

  public preencherDocumento() {
    // documentos do adiantamento
    this.documentoService.obterPorAdiantamento(this.entidade.id).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data: any) => {
          this.listaDocumentos = data ? data.content : new Array<AdiantamentoDocumento>();
        }, error => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: error })
      );
  }

}
